"use strict";

define('model/study.proposal',['./base', './sp.proposal', './study'], function (BaseModel, SPProposal, Study) {
  var StudyProposal = BaseModel.extend({
    virtual: {
      proposalNumber: BaseModel.createKeyPathVirtual('proposal.PROPOSALNUMBER'),
      studyId: BaseModel.createKeyPathVirtual('study.id')
    },
    childModels: {
      proposal: SPProposal,
      study: Study
    },
    createLink: function createLink() {
      var resp = this.request('/rs/api/link/:proposalId/:studyId', {
          type: 'POST'
        }),
        self = this;
      resp.promise().tap(function () {
        self.trigger('linked');
      });
      return resp;
    },
    destroyLink: function destroyLink() {
      var resp = this.request('/rs/api/link/proposal/:proposalId/study/:studyId', {
          type: 'DELETE',
          contentType: 'application/json'
        }),
        self = this;
      resp.promise().tap(function () {
        self.trigger('destroy', self, self.collection, {});
      });
      return resp;
    }
  }, {
    create: function create(study, proposal) {
      return new StudyProposal({
        study: study,
        proposalId: proposal.id,
        proposal: proposal
      });
    },
    allByStudyId: function allByStudyId(studyId) {
      return this.createCollection('/rs/api/link/study/:studyId').params({
        studyId: studyId
      });
    }
  });
  return StudyProposal;
});

